import { OnInit, Directive } from "@angular/core";
import { Observable } from "rxjs";
import {
  UntypedFormGroup,
  UntypedFormBuilder,
  UntypedFormControl,
  Validators,
} from "@angular/forms";

@Directive()
export abstract class BaseFormComponent implements OnInit {
  public form: UntypedFormGroup;
  public submitted: boolean = false;

  formErrors: any;
  protected validationMessages: any;

  constructor(formErrors?: any, validationMessages?: any, fb?: UntypedFormBuilder) {
    this.formErrors = formErrors;
    this.validationMessages = validationMessages;
  }

  abstract initializeForm(): UntypedFormGroup;

  abstract sendForm(): any;

  abstract handleErrors(errors: any);

  ngOnInit() {}

  buildForm() {
    this.form = this.initializeForm();
  }

  onValueChanged(data?: any) {
    if (!this.form) {
      return;
    }
    const form = this.form;
    for (const field in this.formErrors) {
      this.formErrors[field] = "";
      const control = form.get(field);
      if (control && control.dirty && !control.valid) {
        const messages = this.validationMessages[field];
        for (const key in control.errors) {
          this.formErrors[field] += messages[key] + " ";
        }
      }
    }
  }

  public onSubmit(values: Object): Observable<any> {
    for (let c in this.form.controls) {
      this.form.controls[c].markAsDirty();
    }
    this.onValueChanged();

    if (this.form.invalid) return;
    this.submitted = true;
    return this.sendForm();
  }

  addNewField(fieldName: string, mensagem: string) {
    let genericField: UntypedFormControl = new UntypedFormControl(
      "",
      Validators.compose([Validators.required])
    );
    let msg = { required: mensagem };
    this.form.addControl(fieldName, genericField);
    this.validationMessages[fieldName] = msg;
    this.formErrors[fieldName] = "";
  }
}
